import React from 'react';
import { ProductPage } from './pages/ProductPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <ProductPage data-id="element-1" />
    </>;
}